module.exports = __webpack_public_path__ + "img/HY.af8ac4cb.png";